import React from 'react';
import Products from './Products';

const B2BProducts = () => <Products forceB2B={true} />;

export default B2BProducts;
